import { createAction, props } from '@ngrx/store';
import { GetConfigParams, GetConfigResponse } from 'src/app/core';

export enum BrandsActionTypes {
  BrandLineConfigGet = '[Configs] BrandLineConfig Get',
  BrandLineConfigGetSuccess = '[Configs] BrandLineConfig Get Success',
  BrandLineConfigGetFailure = '[Configs] BrandLineConfig Get Failure',
}

// BrandLineConfig
export const actionBrandLineConfigGet = createAction(
  BrandsActionTypes.BrandLineConfigGet,
  props<{ payload: Partial<GetConfigParams> }>(),
);
export const actionBrandLineConfigGetSuccess = createAction(
  BrandsActionTypes.BrandLineConfigGetSuccess,
  props<{ response?: GetConfigResponse }>(),
);
export const actionBrandLineConfigGetFailure = createAction(
  BrandsActionTypes.BrandLineConfigGetFailure,
);
